import React from 'react';
import PropTypes from 'prop-types';
import * as IconsLibrary from './index';

const SvgIcon = ({ icon, ...rest }) => {
  if (icon) {
    const Component = IconsLibrary[icon];

    if (Component && typeof (Component) !== 'undefined') {
      return (<Component {...rest} />);
    }

    return null;
  }

  return null;
};

SvgIcon.propTypes = {
  icon: PropTypes.string,
};

export default SvgIcon;
